<!--
  Nos formulários o guia não prende nem captura o foco dos campos.
  Os tours de apresentação mantêm a navegação restrita ao balão.
-->
<section
  class="mg-tutorial-passo"
  role="dialog"
  [attr.aria-modal]="!interativo"
  [attr.aria-label]="passo.titulo"
  [cdkTrapFocus]="!interativo"
  [cdkTrapFocusAutoCapture]="!interativo"
>
  <header class="mg-tutorial-passo__topo">
    <!--
      Indicador de progresso em DUAS formas de propósito, e o dono escolhe uma
      olhando a tela: os pontinhos dão a noção de "quanto falta" num relance, e
      o texto dá o número — com seis passos, ponto sozinho não se conta de
      olho. `aria-hidden` nos pontos porque o texto ao lado já diz a mesma
      coisa para o leitor de tela; duas leituras da mesma informação é ruído.
    -->
    <span class="mg-tutorial-passo__pontos" aria-hidden="true">
      @for (ponto of pontos; track ponto) {
        <span class="mg-tutorial-passo__ponto" [class.mg-tutorial-passo__ponto--atual]="ponto === indice"></span>
      }
    </span>
    <span class="mg-tutorial-passo__contador">Passo {{ indice + 1 }} de {{ total }}</span>
  </header>

  <h2 class="mg-tutorial-passo__titulo">{{ passo.titulo }}</h2>
  <p class="mg-tutorial-passo__corpo">{{ passo.corpo }}</p>

  <footer class="mg-tutorial-passo__acoes">
    <!--
      "Pular" fica, e fica À ESQUERDA, separado dos outros dois: sair do tour
      não é o passo seguinte de "Anterior/Próximo", é outra decisão.
    -->
    <kt-button appearance="text" (handle)="pular.emit()">Pular</kt-button>

    <span class="mg-tutorial-passo__espaco"></span>

    <kt-button appearance="text" [disabled]="primeiro" (handle)="anterior.emit()">Anterior</kt-button>
    <kt-button appearance="filled" (handle)="proximo.emit()">{{ ultimo ? 'Concluir' : 'Próximo' }}</kt-button>
  </footer>
</section>
